import { render } from "./MedStaff.vue?vue&type=template&id=58f9e516"
import script from "./MedStaff.vue?vue&type=script&lang=js"
export * from "./MedStaff.vue?vue&type=script&lang=js"

import "./MedStaff.vue?vue&type=style&index=0&id=58f9e516&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__